module.exports = __webpack_public_path__ + "static/img/futian-2.d149ea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/futian-2.png
// module id = 166
// module chunks = 1